import { FC, useMemo } from "react";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";

type Props = {
  isLoading: boolean;
  count: number;
};

export const HeadsUpFindMoreMessage: FC<Props> = ({ isLoading, count }) => {
  const message = useMemo(() => {
    if (isLoading) {
      return "Mem is still searching, this may take a minute...";
    }

    if (count > 0) {
      const noun = count === 1 ? "card" : "cards";
      return `Found ${count} more ${noun}`;
    }

    return "";
  }, [isLoading, count]);

  return (
    <MDSText
      variant={MDSTextVariant.TextXs}
      weight={MDSTextWeight.Regular}
      color={MDSTextColor.Secondary}
    >
      {message}
    </MDSText>
  );
};
